export type AuthUserLike = {
  full_name?: string;
  user_metadata?: Record<string, unknown>;
  email?: string;
} | null;

export function normalizeName(value: string | null | undefined): string {
  return (value || "").trim().toLowerCase();
}

export function getCurrentRepName(user: AuthUserLike): string {
  const metadataName =
    typeof user?.user_metadata?.full_name === "string"
      ? user.user_metadata.full_name
      : "";

  const explicitName = user?.full_name || metadataName;
  if (explicitName?.trim()) {
    return explicitName.trim();
  }

  if (user?.email) {
    const localPart = user.email.split("@")[0] || "";
    return localPart
      .split(/[._-]+/)
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");
  }

  return "";
}
